<div class="row">
  <div class="col-12" *ngIf="response$ | async as response">
    <uni-alert>
      <uni-alert-title class="h2">Solicitud completada exitosamente</uni-alert-title>

      <h6 uni-heading color="lighten" class="darkgray-text">Número de Solicitud: {{ response?.processRadNumber }}</h6>
    </uni-alert>

    <uni-summary *ngIf="newRequest$ | async as newRequest">
      <uni-summary-header alignment="block">
        <uni-summary-section name="Fideicomiso" [description]="newRequest.escrow.sNombreCorto"></uni-summary-section>
        <uni-summary-section name="Área de Solicitud" [description]="newRequest.area.sNombre"></uni-summary-section>
      </uni-summary-header>

      <uni-summary-group heading="Información del Solicitante">
        <uni-summary-section name="Tipo" [description]="newRequest.type.sNombre"></uni-summary-section>
        <uni-summary-section name="SubTipo" [description]="newRequest.subtype.sNombre"></uni-summary-section>
      </uni-summary-group>
      <uni-summary-group heading="Datos de la Solicitud">
        <uni-summary-section name="Descripción" [description]="newRequest.description"></uni-summary-section>
        <uni-summary-section *ngIf="newRequest.stage" name="Etapa" [description]="newRequest.stage.sNombre"></uni-summary-section>
        <uni-summary-section
          *ngIf="newRequest.invoiceQuantity"
          name="Cantidad de Facturas"
          [description]="newRequest.invoiceQuantity"
        ></uni-summary-section>
        <uni-summary-section
          *ngIf="newRequest.amount"
          name="Monto"
          [description]="newRequest.amount | currency : newRequest.amount.sNombre : 'symbol-narrow'"
        ></uni-summary-section>
      </uni-summary-group>
      <uni-summary-group *ngIf="newRequest.customerName" heading="Datos del Cliente">
        <uni-summary-section name="Nombre del Cliente" [description]="newRequest.customerName"></uni-summary-section>
        <uni-summary-section
          name="Tipo de Identificación"
          [description]="newRequest.identificationType.sNombreID"
        ></uni-summary-section>
        <uni-summary-section name="Número de Identificación" [description]="newRequest.identification"></uni-summary-section>
        <uni-summary-section name="Tipo de Cliente" [description]="newRequest.customerType.sNombre"></uni-summary-section>
      </uni-summary-group>

      <uni-summary-group
        *ngIf="newRequest?.files"
        heading="Documentos: {{ newRequest?.files?.length ?? 0 }} ({{
          getFilesSizeMegaBytes1X1(newRequest?.files ?? [], 3)
        }} mbs)"
      >
        <ng-container *ngIf="newRequest?.files?.length">
          <ng-container *ngFor="let group of getRequestFilesGroups(newRequest?.files ?? [])">
            <h4 style="font-size: 13px; margin: 0px">{{ group.name }}</h4>
            <table style="width: 100%; font-size: 12px; margin-bottom: 10px">
              <caption></caption>
              <thead>
                <tr>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let file of group.files; index as k">
                  <tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.05)">
                    <td style="text-align: left; padding: 5px">
                      {{ file?.file?.name }}<br />
                      <span
                        style="
                          background-color: #e8edf7;
                          padding: 1px 6px;
                          box-sizing: border-box;
                          border-radius: 50px;
                          font-size: 10px;
                          color: dodgerblue;
                        "
                      >
                        {{ getSizeMegaBytes(file?.file?.object?.size, 3) }} mb
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!newRequest?.files?.length">
          <p style="text-align: center">Sin Documentos</p>
        </ng-container>
      </uni-summary-group>
    </uni-summary>
  </div>

  <div class="col-12 text-right mt-5">
    <button uni-button (click)="onNewRequest()">Crear Nueva Solicitud</button>
  </div>
</div>
